// @ts-check
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  MenuItem,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText
} from '@material-ui/core';

import { editBranchThreePlAction } from '../redux/actions/branch-actions';
import { SnackbarComponent } from '../../../../core/utils/components/snackbar-component';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  maringCancel: {},
  formButtons: {
    marginTop: theme.spacing(4)
  },
  errorText: {
    color: '#f44336',
    textAlign: 'center',
    display: 'block',
    margin: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  dialog: {
    top: '25%',
    left: 0,
    right: 0,
    margin: '0 auto',
    padding: '0 20px'
  }
}));

function SelectBranchThirdPartyLogisticsPartner(props) {
  const classes = useStyles();
  const { loading } = useSelector((state) => state.loading);
  const [isOpen, setIsOpen] = useState(false);

  const [selectedOption, setSelectedOption] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, status: 'success', message: '' });
  const showSnackbar = (status, message) => setSnackbar({ open: true, status, message });

  const close = () => {
    setIsOpen(false);
  };
  const { branch, settings } = props;

  return (
    <div>
      <TextField
        id="branch-select-3pl-partner-component-partner"
        select
        label="Partner"
        variant="outlined"
        fullWidth={true}
      >
        {settings.partners.map((option) => (
          <MenuItem key={option.id} value={option.name} onClick={() => setSelectedOption(option)}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>

      <div className={classes.formButtons}>
        {!loading && (
          <>
            <Button
              className={classes.margin}
              type="submit"
              variant="contained"
              size="large"
              color="primary"
              fullWidth={true}
              disabled={!selectedOption.id}
              onClick={() => setIsOpen(true)}
            >
              Save Changes
            </Button>
          </>
        )}

        {loading && (
          <Button
            className={classes.margin}
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
          >
            <CircularProgress color="inherit" size={26} />
          </Button>
        )}
        <ConfirmModal
          open={isOpen}
          handleModalClose={close}
          branch={branch}
          partner={selectedOption}
          setIsOpen={setIsOpen}
          showSnackbar={showSnackbar}
        />
        <SnackbarComponent
          open={snackbar.open}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.status}
          message={snackbar.message}
        />
      </div>
    </div>
  );
}

function ConfirmModal(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  // The partner is only written once the admin confirms it here.
  const editBranchThreePl = (props) => {
    dispatch(
      editBranchThreePlAction(props.branch.id, props.partner.id, {
        showSnackbar: props.showSnackbar
      })
    );
  };
  return (
    <div>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          <strong>Confirm 3PL selection</strong>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want all orders for <strong> {props.branch.name}</strong> branch to be
            sent to <strong>{props.partner.name}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
            className={classes.margin}
            onClick={() => {
              props.setIsOpen(false);
              editBranchThreePl(props);
            }}
          >
            Yes
          </Button>
          <Button
            className={classes.maringCancel}
            onClick={() => props.setIsOpen(false)}
            variant="outlined"
            size="large"
            color="secondary"
            fullWidth={true}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export function SelectBranchThirdPartyPartnerComponent({ branch }) {
  const { settings } = useSelector((state) => state.settings);

  return <SelectBranchThirdPartyLogisticsPartner branch={branch} settings={settings} />;
}
